import React from 'react';
import '@/App.css';
import { Toaster } from 'sonner';
import { useLenis } from '@/hooks/useLenis';
import { Nav } from '@/components/site/Nav';
import { Hero } from '@/components/site/Hero';
import { SecondScroll } from '@/components/site/SecondScroll';
import { Belief } from '@/components/site/Belief';
import { Founders } from '@/components/site/Founders';
import { Podcast } from '@/components/site/Podcast';
import { Substack } from '@/components/site/Substack';
import { FinalCTA } from '@/components/site/FinalCTA';
import { Footer } from '@/components/site/Footer';

function App() {
  useLenis();

  // Dev/test helper: ?only=<section> renders a single section for inspection.
  const only = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('only')
    : null;
  if (only) {
    const map = { second: <SecondScroll />, belief: <Belief />, founders: <Founders />, podcast: <Podcast />, substack: <Substack />, final: <FinalCTA />, footer: <Footer /> };
    return (
      <div className="App relative">
        <div className="grain-overlay" />
        <Nav />
        <main className="pt-24">{map[only]}</main>
      </div>
    );
  }

  return (
    <div className="App relative">
      <div className="grain-overlay" />
      <Nav />
      <main>
        <Hero />
        <SecondScroll />
        <Belief />
        <Founders />
        <Podcast />
        <Substack />
        <FinalCTA />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#04252A',
            color: '#F4EDE5',
            border: 'none',
            borderRadius: '0',
            fontFamily: 'Lexend, sans-serif',
            letterSpacing: '0.02em',
          },
        }}
      />
    </div>
  );
}

export default App;
